class ProductCard extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("mouseenter", this.onMouseEvent.bind(this));
    this.addEventListener("mouseleave", this.onMouseEvent.bind(this));
  }

  disconnectedCallback() {
    this.addEventListener("mouseenter", this.onMouseEvent.bind(this));
    this.addEventListener("mouseleave", this.onMouseEvent.bind(this));
  }

  onMouseEvent(event) {
    if (is_touch_device()) return;
    if (event.type === "mouseenter") {
      this.style.height = this.getBoundingClientRect().height + "px";
      this.classList.add("hovered");
    } else if (event.type === "mouseleave") {
      this.classList.remove("hovered");
      this.style.removeProperty("height");
    }
  }
}
customElements.define("product-card", ProductCard);
